import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import InvestorDeck from 'src/entities/InvestorDeck';

export interface ApiInvestorDeckResponse {
  investorDeck: {
    id: number
    investorDeckDocument: string;
    personId: number;
    personType: string;
    };
}

interface ApiInvestorDeckCreateRequest {
}

export class InvestorDeckFactory extends BaseFactory<InvestorDeck> {
  public toEntity(args: ApiInvestorDeckResponse): InvestorDeck {
    return new InvestorDeck({
      id: args.investorDeck.id,
      investorDeckDocument: args.investorDeck.investorDeckDocument,
      personId: args.investorDeck.personId,
      personType: args.investorDeck.personType,
    });
  }

  public toRequest(investorDeck: InvestorDeck): ApiInvestorDeckCreateRequest {
    return investorDeck;
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/InvestorDeckFactory.tsx